export const AUTH_EXPIRED_EVENT = "finster-auth-expired";

export function notifyAuthExpired(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  }
}

export function checkAuthStatus(response: Response): void {
  if (response.status === 401) {
    notifyAuthExpired();
  }
}
